import { useEffect, useState, React } from "react";
import { useNavigate } from "react-router-dom"
import Form from "react-bootstrap/Form";
import axios from "axios";
//Hooks
import { useAuthContext } from "../Hooks/useAuthContext";


export default function CreateUser() {

    const [form, setForm] = useState({});
    const [formErrors, setFormErrors] = useState();
    const {dispatch } = useAuthContext();
    const [loginErr, setLoginErr] = useState("");
    const navigate = useNavigate();

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {


    }, [form]);
 

    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            email: form.email == undefined || form.email == "",
            password: form.password == undefined || form.password == ""
        });

        
        if (event.currentTarget.checkValidity()) {
            axios
                .post(`https://${process.env.REACT_APP_IP}/api/users/login/`, form)
                .then((res) => {
                    console.log("login success")
                    if (res.status === 200) {
                        dispatch({ type: "LOGIN", payload: res.data });
                        navigate(`/`) 
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 400) {
                        setLoginErr(err.response.data[0]);
                    }
                });
        }
    }


    return (
        <main className="justify-content-center row align-content-center px-2 px-md-0" style={{ height: "90vh" }}>
            <div className="loginForm shadow p-3 col-md-5">
                <h1 className="text-center mb-3">Welcome to EcoProspects</h1>

                <Form onSubmit={handleSubmit} noValidate >

                    { /* Email */}
                    <div className="row">
                        <div className="col-12">
                            <Form.Group>
                                <label>Email</label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="example@email.com"
                                    isInvalid={formErrors && formErrors.email}
                                    onChange={(e) => setField("email", e.target.value)}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    Email is required
                                </Form.Control.Feedback>
                                
                            </Form.Group>
                        </div>
                    </div>

                    { /* Password */}
                    <div className="row">
                        <div className="col-12">
                            <Form.Group>
                                <label>Password</label>
                                <Form.Control
                                    required
                                    type="password"
                                    isInvalid={formErrors && formErrors.password}
                                    onChange={(e) => setField("password", e.target.value)}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    Password is required
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>
                    </div>

                    {loginErr && (
                        <div className="row">
                            <div className="col-12">
                                <span className="loginErr text-danger">
                                    {loginErr}
                                </span>
                            </div>
                        </div>
                       
                    )}

                    <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-6">
                            <button type="submit" className="btn btn-primary">Login</button>
                        </div>
                        <div className="col-6 text-end">
                            <a href="" onClick={() => { navigate("ResetPassword") }}>Reset Password?</a>
                        </div>
                    </div>
                </Form>
            </div>
        </main>
    )
}


